<div class="general-container">
  <span class="general-container__title">Selecciona un cliente</span>
  <mg-input
    class="general-container__icon"
    id="search-transaction"
    [placeholder]="'Buscar...'"
    mgIcon="search_normal"
    [control]="$any(searchForm.get('searchField'))"
    [value]="searchForm.value.searchField"
  ></mg-input>
  <ng-container *ngIf="clients.length > 0; else noClientsTemplate">
    <div
      class="general-container__clients"
      [ngClass]="{ '!w-auto !flex-nowrap flex-col': bp.isCompact() }"
    >
      <ng-container *ngFor="let client of clients">
        <div
          class="general-container__clients__client"
          (click)="selectClient(client)"
          (keypress.enter)="selectClient(client)"
          (keypress.space)="selectClient(client)"
        >
          <span class="general-container__clients__client__initials">{{
            getInitials(client.name)
          }}</span>
          <span class="general-container__clients__client__name">{{
            client.name
          }}</span>
        </div>
      </ng-container>
    </div>
  </ng-container>
  <ng-template #noClientsTemplate>
    <div class="general-container__no-clients">
      <mg-icons
        class="general-container__no-clients__icon"
        name="info-circle-clients"
      >
      </mg-icons>
      <div class="general-container__no-clients__text-container">
        <span class="general-container__no-clients__text-container__title"
          >¡Oops!</span
        >
        <span class="general-container__no-clients__text-container__description"
          >El cliente que buscas aún no es parte de Migo.<br />Intenta con otro
          cliente.</span
        >
      </div>
    </div>
  </ng-template>
</div>
<!-- 
(keydown.enter)="onSubmit()"
(iconClick)="onSubmit()" -->
